<template>
  <v-layout>
    <v-flex>
      <v-form ref="form" v-model="valid">
        <h2>Informatii loc de consum - Tabel Informatii</h2>
        <v-text-field label="4. Numar contract de servicii" v-model="document.contractNr">
        </v-text-field>

        <v-menu ref="menuCheckDateOfConsumptionPlace" v-model="menuCheckDateOfConsumptionPlace"
          :close-on-content-click="false" :return-value.sync="document.checkDateOfConsumptionPlace"
          transition="scale-transition" offset-y min-width="290px">
          <template v-slot:activator="{ on }">
            <v-text-field v-model="document.checkDateOfConsumptionPlace"
              label="6. Data ultimei verificari tehnice efectuate la locul de consum, mentionata in notificare"
              prepend-icon="event" readonly v-on="on"></v-text-field>
          </template>
          <v-date-picker v-model="document.checkDateOfConsumptionPlace" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="menuCheckDateOfConsumptionPlace = false">Cancel</v-btn>
            <v-btn text color="primary" @click="
              $refs.menuCheckDateOfConsumptionPlace.save(
                document.checkDateOfConsumptionPlace
              )
              ">OK</v-btn>
          </v-date-picker>
        </v-menu>

        <h3>9. Aparate consumatoare de combustibili gazosi</h3>
        <v-row>
          <v-col cols="6">
            <h4>Notificate de furnizorul de gaze</h4>
            <v-text-field label="CT" v-model="document.ctNotified">
            </v-text-field>
            <v-text-field label="MA" v-model="document.maNotified">
            </v-text-field>
          </v-col>
          <v-col cols="6">
            <h4>Identificate la locul de consum</h4>
            <v-text-field label="CT" v-model="document.ctIdentified">
            </v-text-field>
            <v-text-field label="MA" v-model="document.maIdentified">
            </v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <h3>Alte aparate</h3>
            <h4>Notificate de furnizorul de gaze</h4>
          </v-col>

          <v-col cols="6">
            <v-text-field label="Nume aparat 1" v-model="document.otherDeviceName1Notified">
            </v-text-field>
            <v-text-field label="Nume aparat 2" v-model="document.otherDeviceName2Notified">
            </v-text-field>
            <v-text-field label="Nume aparat 3" v-model="document.otherDeviceName3Notified">
            </v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field label="Valoare aparat 1" v-model="document.otherDeviceValue1Notified">
            </v-text-field>
            <v-text-field label="Valoare aparat 2" v-model="document.otherDeviceValue2Notified">
            </v-text-field>
            <v-text-field label="Valoare aparat 3" v-model="document.otherDeviceValue3Notified">
            </v-text-field>
          </v-col>

          <v-col cols="12">
            <h4>Identificate la locul de consum</h4>
          </v-col>

          <v-col cols="6">
            <v-text-field label="Nume aparat 1" v-model="document.otherDeviceName1Identified">
            </v-text-field>
            <v-text-field label="Nume aparat 2" v-model="document.otherDeviceName2Identified">
            </v-text-field>
            <v-text-field label="Nume aparat 3" v-model="document.otherDeviceName3Identified">
            </v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field label="Valoare aparat 1" v-model="document.otherDeviceValue1Identified">
            </v-text-field>
            <v-text-field label="Valoare aparat 2" v-model="document.otherDeviceValue2Identified">
            </v-text-field>
            <v-text-field label="Valoare aparat 3" v-model="document.otherDeviceValue3Identified">
            </v-text-field>
          </v-col>
        </v-row>

        <h2>
          (1) Verificarea tehnica a instalatiei de utilizare a gazelor naturale
          se realizeaza in urmatoarele situatii:
        </h2>

        <h3>Tabel 1</h3>
        <v-radio-group v-model="document.reasonOfIntervention">
          <v-radio label="La intervale de maximum 2 ani" value="1"></v-radio>
          <v-radio label="La cererea clientului final" value="2"></v-radio>
        </v-radio-group>

        <h3>Tabel 2</h3>
        <v-menu ref="menuCheckDate2Table2" v-model="menuCheckDate2Table2" :close-on-content-click="false"
          :return-value.sync="document.checkDate2Table2" transition="scale-transition" offset-y min-width="290px">

          <template v-slot:activator="{ on }">
            <v-text-field v-model="document.checkDate2Table2"
              label="2. Verificarea tehnica a instalatiei comune de utilizare a gazelor naturale" prepend-icon="event"
              readonly v-on="on"></v-text-field>
          </template>
          <v-date-picker v-model="document.checkDate2Table2" no-title scrollable>
            <v-btn text color="primary"
              @click="document.checkDate2Table2 = null; $refs.menuCheckDate2Table2.save(document.checkDate2Table2)">Sterge
              data</v-btn>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="menuCheckDate2Table2 = false">Cancel</v-btn>
            <v-btn text color="primary" @click="
              $refs.menuCheckDate2Table2.save(document.checkDate2Table2)
              ">OK</v-btn>
          </v-date-picker>
        </v-menu>

        <h3>Tabel 4</h3>

        <v-row>
          <v-col cols="6">
            <h4>Defect 1</h4>

            <v-text-field label="1. Defecte constatate" v-model="document.issuesFound1" />
            <v-text-field label="1. Modul de remediere a defectelor 4)" v-model="document.issuesFixDescription1" />
            <v-switch label="1. De completat* daca s-au remediat defectele" v-model="document.issuesFixed1"
              class="mx-2" />
          </v-col>

          <v-col cols="6">
            <h4>Defect 2</h4>

            <v-text-field label="2. Defecte constatate" v-model="document.issuesFound2" />
            <v-text-field label="2. Modul de remediere a defectelor 4)" v-model="document.issuesFixDescription2" />
            <v-switch label="2.. De completat* daca s-au remediat defectele" v-model="document.issuesFixed2"
              class="mx-2" />
          </v-col>

        </v-row>

        <SignaturePad ref="signatureRef" />

        <div class="text-xs-right">
          <v-btn @click="submit" color="primary">Salvare</v-btn>
          <v-btn @click="preview" color="primary">Previzualizare</v-btn>
        </div>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
import SignaturePad from '@/components/documents/SignaturePad.vue';
import { busEvent } from '../../main';

export default {
  components: {
    SignaturePad,
  },

  data() {
    return {
      valid: true,
      menuCheckDateOfConsumptionPlace: false,
      menuCheckDate2Table2: false,
      document: {
        type: 'vtp-anre-2-srb',
        consumptionCode: '',
        contractNr: '',
        signature: null,
        checkDateOfConsumptionPlace: new Date().toISOString().substr(0, 10),
        checkDate2Table2: new Date().toISOString().substr(0, 10),
        ctNotified: 2.70,
        maNotified: 0.67,
        ctIdentified: 2.70,
        maIdentified: 0.67,

        otherDeviceName1Notified: '-',
        otherDeviceValue1Notified: '-',
        otherDeviceName2Notified: '-',
        otherDeviceValue2Notified: '-',
        otherDeviceName3Notified: '-',
        otherDeviceValue3Notified: '-',
        otherDeviceName1Identified: '-',
        otherDeviceValue1Identified: '-',
        otherDeviceName2Identified: '-',
        otherDeviceValue2Identified: '-',
        otherDeviceName3Identified: '-',
        otherDeviceValue3Identified: '-',

        issuesFound1: '-',
        issuesFixDescription1: '-',
        issuesFixed1: false,
        issuesFound2: '-',
        issuesFixDescription2: '-',
        issuesFixed2: false,

        reasonOfIntervention: '-',

      },
      priceRevisionRules: [
        (element) => {
          if (!element) return 'Campul trebuie completat';
          return true;
        },
      ],
    };
  },

  async created() {
    // check if we're on edit screen
    if (this.$route.name === 'Editare VTP ANRE 2 ani SRB') {
      const document = await this.$store.dispatch('documents/getDocument', {
        clientId: this.$route.params.clientId,
        documentId: this.$route.params.id,
      });

      this.document = {
        ...document.props,
        documentId: document.id,
        number: document.number,
      };
      this.$refs.signatureRef.setSignature(document.props.signature);
    } else {
      const lastDocument = await this.$store.dispatch(
        'documents/getLastDocument',
        {
          documentType: 'vtp-anre-2-srb',
        }
      );

      this.document.contractNr = lastDocument.number + 1;
    }
  },
  methods: {
    submit() {
      if (this.$refs.form.validate() && this.valid) {
        this.document.signature = this.$refs.signatureRef.getSignature();

        if (this.$route.name === 'Editare VTP ANRE 2 ani SRB') {
          this.$store
            .dispatch('documents/update', {
              clientId: this.$route.params.clientId,
              body: this.document,
            })
            .then(() => {
              busEvent.$emit(
                'succesPopupCreated',
                'VTP la 2 ani a fost editat'
              );
              this.$router.back();
            });
        } else {
          this.$store
            .dispatch('documents/create', {
              clientId: this.$route.params.clientId,
              body: this.document,
            })
            .then(() => {
              busEvent.$emit('succesPopupCreated', 'VTP la 2 ani a fost creat');
              this.$router.back();
            });
        }
      }
    },
    async preview() {
      if (this.$refs.form.validate() && this.valid) {
        this.document.signature = this.$refs.signatureRef.getSignature();

        const response = await this.$store.dispatch('documents/preview', {
          clientId: this.$route.params.clientId,
          body: this.document,
        });

        const fileURL = window.URL.createObjectURL(new Blob([response.data]));
        const fileLink = document.createElement('a');
        fileLink.href = fileURL;
        const fileName =
          response.headers['content-disposition'].match("filename='(.*)'");
        fileLink.setAttribute('download', fileName[1]);
        document.body.appendChild(fileLink);
        fileLink.click();
        fileLink.remove();
      }
    },
  },
};
</script>

<style></style>
